/**
 * Shared TanStack Query keys for the games/game-sessions surface
 * (docs/APP_PLAN.md §5.2, §12 M3). Declared once so `CatalogPage` (which
 * seeds the cache on session creation) and `GameHostPage` (which reads it)
 * can never drift apart.
 */
export const GAME_CATALOG_QUERY_KEY = ['games', 'catalog'] as const;

export function gameSessionQueryKey(sessionId: string) {
  return ['game-sessions', sessionId] as const;
}

/**
 * The shared prefix for every `GET /api/game-sessions?status=...` list
 * query (dashboard's active/completed sections, and the History page's
 * larger completed-games list, docs/APP_PLAN.md §12 M6). A forfeit or a
 * block-triggered forfeit cascade can change any of these lists, so
 * mutations that trigger one invalidate this whole prefix rather than each
 * caller having to remember every specific list key.
 */
export const GAME_SESSIONS_LIST_QUERY_KEY = ['game-sessions', 'list'] as const;

export const ACTIVE_SESSIONS_QUERY_KEY = [...GAME_SESSIONS_LIST_QUERY_KEY, 'active'] as const;

export const COMPLETED_SESSIONS_QUERY_KEY = [...GAME_SESSIONS_LIST_QUERY_KEY, 'completed'] as const;

/** The History page's completed-games list — a distinct cache entry from the dashboard's shorter one (different `limit`). */
export const SESSION_HISTORY_QUERY_KEY = [
  ...GAME_SESSIONS_LIST_QUERY_KEY,
  'completed',
  'history',
] as const;
